(function () {
  var SKIP = { all: true, frontpage: true, vendors: true };
  var KEY = 'ff_gym_store';

  function collectionHandle(url) {
    var match = (url || '').match(/^\/collections\/([a-z0-9-]+)(?:[\/?#]|$)/i);
    return match && !SKIP[match[1]] ? match[1] : null;
  }

  function remember(handle) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ url: '/collections/' + handle, handle: handle }));
    } catch (error) {}
  }

  function stored() {
    try {
      var data = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return data && data.url ? data : null;
    } catch (error) {
      return null;
    }
  }

  // 1. Remember the gym from the URL (collection and collection/product pages).
  var fromPath = collectionHandle(window.location.pathname || '');
  if (fromPath) remember(fromPath);

  // 2. Remember the gym from a product page's server-computed "back to store" link,
  //    so direct product links (email, share, search) also set the gym.
  if (!fromPath && /^\/products\//.test(window.location.pathname || '')) {
    var back = document.querySelector('.ff-back a[href^="/collections/"], [data-ff-continue][href^="/collections/"]');
    var fromPage = back ? collectionHandle(back.getAttribute('href')) : null;
    if (fromPage) remember(fromPage);
  }

  // 3. Point generic "continue shopping" links at the remembered gym. Re-applied whenever the
  //    cart drawer / cart page re-renders (empty-cart state is fetched from "/" and would
  //    otherwise come back pointing at /collections/all).
  function apply() {
    var data = stored();
    if (!data) return;
    document.querySelectorAll('[data-ff-continue]').forEach(function (link) {
      var current = link.getAttribute('href') || '';
      if (current.indexOf('/collections/all') !== -1 || current === '/' || current === '') {
        link.setAttribute('href', data.url);
      }
    });
  }

  apply();

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; apply(); }, 50);
  }
  try {
    if (window.MutationObserver && document.body) {
      new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    }
  } catch (error) {}
  document.addEventListener('cart:refresh', scheduleApply);
  window.addEventListener('pageshow', scheduleApply);
})();
